import React, { useEffect, useState } from "react";
import GlobalDialog from "../../../../components/mui/Dialogue/GlobalDialog";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import {
  AddButton,
  CancelButton,
  EditButton,
  SubmitButton,
  UpdateButton,
} from "../../../../components/mui/Buttons/Buttons";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Autocomplete, Box, Stack, TextField } from "@mui/material";
import { createSale, getAllProductsWithoutPagination, getSale, updateSale } from "../../../../redux/features/assetManagementSlice";
import { useSelector } from "react-redux";
import GlobalSelectField from "../../../../components/mui/GlobalSelectField";
import { savePaginationData } from "../../../../redux/features/globalDatagridSlice";

export const RequirementTypes = [
  { id: 1, value: "Freebie" },
  { id: 2, value: "Asset" },
  { id: 3, value: "Petty" },
];
const AddOrUpdateRequirementRequest = ({ row, dispatchParams, disable, isNotRequestRaiser }) => {
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const { loading, productDataForRequirement } = useSelector(
    (store) => store.assetmanagement
  );

  const handleCancel = () => {
    setOpen(false);
    formik.resetForm();
  };

  const initialValues = {
    subCategoryId: row ? row.subCategoryId : "",
    count: row ? row.count : "",
    remarks: row ? row.remarks : "",
  };

  const schema = Yup.object({
    subCategoryId: Yup.string().required("Item is required"),
    // remarks: Yup.string().required("Remarks is required"),
    count: Yup.number().required("QTY is required"),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: schema,
    onSubmit: (values) => {
      const data = { ...values }
      if (row) {
        const updateData = { ...data, id: row.salesID };
        dispatch(updateSale(updateData)).then((res) => {
          if (res.payload.status === "error") {
            enqueueSnackbar(res.payload.message, {
              variant: "error",
            });
          } else if (res.payload.status === "success") {
            handleCancel()
            dispatch(getSale(dispatchParams))
            dispatch(
              savePaginationData({ ...paginationData, openAnchor: false })
            );
            enqueueSnackbar(res.payload.message, {
              variant: "success",
            });
          }
        });
      } else {
        dispatch(createSale(data)).then((res) => {
          if (res.payload.status === "error") {
            enqueueSnackbar(res.payload.message, {
              variant: "error",
            });
          } else if (res.payload.status === "success") {
            handleCancel();
            dispatch(getSale(dispatchParams))
            enqueueSnackbar(res.payload.message, {
              variant: "success",
            });
          }
        });
      }
    },
  });


  const handleProductChange = (event, option) => {
    const fieldName = event.target?.id.split("-")[0];
    formik.setFieldValue(fieldName, option?.sub_category_id);
  };
  return (
    <GlobalDialog
      maxWidth={"sm"}
      fullWidth
      title={"Add Request"}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      closeCondition={handleCancel}
      popupButton={
        <>
          {row ? (
            <EditButton
              disabled={disable || isNotRequestRaiser}
              size="small"
              variant={"outlined"}
              action={() => setOpen(true)}
            >
              Edit Request
            </EditButton>
          ) : (
            <AddButton size={"large"} action={() => setOpen(true)}>
              Add Request
            </AddButton>
          )}
        </>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Stack gap={1}>
                  <Autocomplete
                    disabled={loading}
                    name="subCategoryId"
                    id="subCategoryId"
                    options={
                      Array.isArray(productDataForRequirement?.data) ? productDataForRequirement.data : []
                    }
                    getOptionLabel={(option) => option?.sub_category_name || ""}
                    value={
                      (productDataForRequirement?.data?.length &&
                        productDataForRequirement?.data?.find(
                          (product) =>
                            product?.sub_category_id == formik.values.subCategoryId
                        )) ||
                      null
                    }
                    onChange={handleProductChange}
                    renderInput={(params) => (
                      <TextField
                        disabled
                        fullWidth
                        autoComplete="off"
                        {...params}
                        label="Item"
                        error={
                          formik.touched.subCategoryId &&
                          Boolean(formik.errors.subCategoryId)
                        }
                        helperText={
                          formik.touched.subCategoryId && formik.errors.subCategoryId
                        }
                      />
                    )}
                  />
                  <TextField
                    autoComplete="off"
                    fullWidth
                    id={"count"}
                    type="number"
                    label="Quantity"
                    name={`count`}
                    value={formik.values.count}
                    onChange={formik.handleChange}
                    error={
                      formik.touched?.count && Boolean(formik.errors?.count)
                    }
                    helperText={
                      formik.touched?.count ? formik.errors?.count : ""
                    }
                    onWheel={(e) => e.target.blur()}
                    inputProps={{
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                      onWheel: (e) => e.target.blur(),
                    }}
                  />
                  <TextField
                    autoComplete="off"
                    fullWidth
                    id="remarks"
                    label="Remarks"
                    name="remarks"
                    value={formik.values.remarks}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.remarks && Boolean(formik.errors.remarks)
                    }
                    helperText={formik.touched.remarks && formik.errors.remarks}
                  />
                </Stack>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                <Stack direction={"row"} spacing={1}>
                  <CancelButton action={() => handleCancel()}>
                    Cancel
                  </CancelButton>
                  {row ? (
                    <UpdateButton disabled={loading} type="submit">
                      {loading ? "Updating..." : "Update"}
                    </UpdateButton>
                  ) : (
                    <SubmitButton disabled={loading} type="submit">
                      {loading ? "Submiting..." : "Submit"}
                    </SubmitButton>
                  )}
                </Stack>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default AddOrUpdateRequirementRequest;
